import React from "react";
import { useTranslation } from "react-i18next";
import Button from "../../../../../components/Button";

interface ButtonsProps {
  loading: boolean;
  view?: boolean;
  actionTwoLoading?: boolean;
  edit?: boolean;
  onSubmit: (action: '1' | '2', e?: React.FormEvent) => void;
  onCancel: () => void;
}

const Buttons: React.FC<ButtonsProps> = ({
  loading, view, edit, actionTwoLoading, onSubmit, onCancel
}) => {
  const { t } = useTranslation()

  return (
    <div className="p-4">
      {
        !view && (
          <>
            <Button
              className="btn btn-primary me-3"
              text={t("vendor.addEdit.pageTexts.form.buttons.save")}
              disabled={loading || actionTwoLoading}
              loading={loading}
              onClick={(e) => onSubmit('1', e)}
            />

            {
              !edit && (
                <Button
                  className="btn btn-primary me-3"
                  text={t("vendor.addEdit.pageTexts.form.buttons.saveAndCreateNew")}
                  disabled={loading || actionTwoLoading}
                  loading={actionTwoLoading}
                  onClick={(e) => onSubmit('2', e)}
                />
              )
            }
          </>
        )
      }
      <Button className="btn btn-outline-secondary" text={t("vendor.addEdit.pageTexts.form.buttons.cancel")} onClick={onCancel} />
    </div>
  )
};

export default Buttons;